export const ANALYTICS = {
    category: {
        fullBuy: 'fullbuy',
    },
    action: {
        clickGuide: 'click_guide',
        goToPage: 'go_to_page_full_buy',
    },
};
